<template>
  <parent>
    <div
      v-if="!fetchingDrm"
      class="top-fade-in container"
    >
      <b-row class="justify-content-center">
        <b-col cols="12">
          <paper>
            <b-row
              class="mt-n2 px-2 py-1 justify-content-end align-items-center"
            >
              <b-col>
                <div class="text-thick">
                  DRM Configuration Details
                </div>
              </b-col>
              <b-col class="d-flex justify-content-end">
                <b-button
                  variant="bg-white"
                  class="mr-1"
                  :to="{ name: 'drm-edit' }"
                >
                  <GjIcon
                    name="Settings"
                    class="icon-left"
                  />
                  Configure
                </b-button>
              </b-col>
            </b-row>
          </paper>
        </b-col></b-row>
      <b-row
        v-if="noDrm"
        class="justify-content-center"
      >
        <b-col cols="12">
          <paper-simple>
            <div class="text-center p-4">
              <span class="text-secondary">
                <GjIcon
                  name="Files"
                  size="60"
                  class="mb-1"
                />
              </span>
              <p class="text-md mb-1 pb-0">
                You haven't configured DRM yet.
              </p>
              <router-link :to="{ name: 'drm-edit' }">
                <a class="text-primary">
                  Click here to add DRM settings
                </a>
              </router-link>
            </div>
          </paper-simple>
        </b-col>
      </b-row>
      <drm-view
        v-else
        :drm-settings="drmSettings"
      />
    </div>
    <loading-page v-else />
  </parent>
</template>

<script>
import Paper from '@/components/paper/Paper.vue'
import DrmView from './view/DrmView.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'DRM',
  components: {
    Paper,
    DrmView,
  },
  data() {
    return {}
  },
  computed: {
    noDrm() {
      return this.$store.state.drm.noDrm
    },
    drmSettings() {
      return this.$store.state.drm.drm
    },
    fetchingDrm() {
      return this.$store.state.drm.fetchingDrm
    },
  },
  created() {
    this.fetchDrm()
    if (this.$route.params.toast) {
      const { toast } = this.$route.params
      this.successToast(toast.message)
    }
  },
  methods: {
    fetchDrm() {
      this.$store.dispatch('drm/getDrm').catch(err => redirectError(err))
    },
  },
}
</script>
